import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import CustomChart from './Chart';

function TotalUnitsSold(props) {
	const { t } = useTranslation('dashboard', 'month');
	const useStyles = makeStyles((theme) => ({
		root: {
			padding: theme.spacing(2),
		},
		chart: {
			height: theme.spacing(42),
		},
	}));
	const classes = useStyles();
	const stats = {
		ordered: props.ordered,
	};

	return (
		<div style={{ width: '100%' }}>
			<Box
				display="flex"
				justifyContent="center"
				pb={3}
				pt={1}
				flexDirection="column"
			>
				<Box justifyContent="center" display="flex">
					<Typography variant="heading5">
						{t('dashboard:total_units')}
					</Typography>
				</Box>
				<Box justifyContent="center" display="flex">
					<Typography variant="body">{props.dateRangeLabel}</Typography>
				</Box>
			</Box>
			<Box p={3}>
				<CustomChart
					className={classes.chart}
					data={stats}
					labels={props.labels}
				/>
			</Box>
		</div>
	);
}

TotalUnitsSold.propTypes = {
	ordered: PropTypes.array.isRequired,
	labels: PropTypes.array.isRequired,
	dateRangeLabel: PropTypes.string.isRequired,
};

export default TotalUnitsSold;
